/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { MinusCheckbox, Check } from 'assets/icons';

import * as S from './Checkbox.styled';

export const CheckboxInner = memo(
  ({
    id,
    name,
    onChange,
    isChecked = false,
    isDisabled = false,
    isOpenGroup = false,
    label,
    style,
    checkedStyle,
    labelStyle,
    readOnly = false,
  }) => {
    return (
      <S.Container style={style}>
        <S.StyledLabel
          style={checkedStyle}
          isChecked={isChecked}
          isDisabled={isDisabled}
          htmlFor={id}
        >
          {isChecked && isOpenGroup && <MinusCheckbox />}
          {isChecked && !isOpenGroup && <Check />}
          <S.Checkbox
            id={id}
            name={name}
            checked={isChecked}
            onChange={onChange}
            disabled={isDisabled}
            readOnly={readOnly}
            onClick={(event) => readOnly && event.stopPropagation()}
          />
        </S.StyledLabel>
        {label && (
          <label style={labelStyle} htmlFor={id}>
            {label}
          </label>
        )}
      </S.Container>
    );
  },
);

CheckboxInner.displayName = 'CheckboxInner';
